import classNames from 'classnames/bind';
import { ColumnTag } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { DragSource } from 'react-dnd';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Enums from 'utils/EnumsManager';
import { moveToZone } from 'views/ReportTableSetup/flow/actions';
import styles from '../index.less';

const cx = classNames.bind(styles);
const { FieldTypes, DROPZONES } = Enums;
const { NumberInput } = FieldTypes;
const { SIDER } = DROPZONES;

class Tag extends PureComponent {
  render() {
    const {
      id,
      label,
      type,
      disabled,
      connectDragSource,
      fieldRestricted,
    } = this.props;

    const disabledCls = disabled || fieldRestricted ? cx('disabled') : '';
    return connectDragSource(
      <div className={`${cx('tag')} text-left ${disabledCls}`}>
        <ColumnTag>
          <div className="truncate">
            {label}
          </div>
        </ColumnTag>
      </div>
    );
  }
}

const getType = props => props.type;
const spec = {
  canDrag: props => !props.disabled && !props.fieldRestricted,

  beginDrag: (props, monitor, component) => {
    return { id: props.id };
  }
};
const collect = (connector, monitor) => ({
  connectDragSource: connector.dragSource(),
  isDragging: monitor.isDragging()
});
const mapStateToProps = ({ global }) => ({
  lang: global.language
});
const mapDispatchToProps = {
  moveToZone
};

const enhancers = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  DragSource(getType, spec, collect)
);

export default enhancers(Tag);



// WEBPACK FOOTER //
// ./src/views/ReportSetup/components/LeftSider/components/Tag.jsx